import React from "react";
import PropTypes from "prop-types";
import {Col, FormGroup, Input} from "reactstrap";
import AsteriskIcon from "../../asteriskIcon";
import HelpIcon from "../../HelpIcon/HelpIcon";

const InputCreator = (props) => {
  const {
    description,
    label,
    label_for,
    inSingleRow = false,
    large = false,
    colSize = "6",
    isRequired = false,
    help_text,
    error,
    ...rest
  } = props;
  return (
    <Col md={large ? "12" : colSize}>
      <FormGroup row>
        <Col md={inSingleRow ? 3 : 12}>
          <div className="d-flex">
            {label && (
              <label className="form-control-label roboto-bold" htmlFor={label_for}>
                {label}
              </label>
            )}
            {isRequired && <AsteriskIcon />}
            {help_text && (
              <span style={{padding: "0px 5px"}}>
                <HelpIcon text={help_text} target={label} place="right" />
              </span>
            )}
          </div>
        </Col>
        <Col md={inSingleRow ? 9 : 12}>
          <Input className="form-control-alternative" invalid={!!error} {...rest} />
          {error && (
            <div className="text-danger small" style={{marginTop: "2px"}}>
              {error}
            </div>
          )}
          {description && (
            <div className="text-muted small" style={{marginTop: "2px"}}>
              {description}
            </div>
          )}
        </Col>
      </FormGroup>
    </Col>
  );
};

InputCreator.propTypes = {
  /** Label for form field */
  label: PropTypes.string,
  /** Wether to show label and input field in single row */
  inSingleRow: PropTypes.bool,
  /** If this prop is set to true then this component will take 100% width of parent component */
  large: PropTypes.bool,
  /** This prop will be passed as colSize to reactstrap Col component */
  colSize: PropTypes.string,
  /** This prop determines wether form field is required */
  isRequired: PropTypes.bool,
  /** If value is passed for this prop this will be shown as tooltip when hovered on help icon */
  help_text: PropTypes.string,
  /** Message shown in red under the field, the field is marked invalid while it is set */
  error: PropTypes.string,
};

export default InputCreator;
